"use strict";

var core = require("../helpers/core");
var gaTracking = require("./tracking");

var optimizelyProjectId = "6153560710";

var sendOptimizelyEvent = function(projectId, eventName, eventId, userId, experimentId, variationId, revenueGoalId, eventValue) {
  var url = "https://" + projectId + ".log.optimizely.com/event";
  eventId = revenueGoalId ? eventId + "," + revenueGoalId : eventId;
  url += "?a=" + projectId;
  url += "&n=" + eventName;
  if (eventId) {
    url += "&g=" + eventId;
  }
  url += "&u=" + encodeURIComponent(userId);
  url += "&x" + experimentId + "=" + variationId;
  if (revenueGoalId) {
    url += "&v=" + eventValue;
  }
  url += "&wxhr=true";

  var xhr = new XMLHttpRequest();
  xhr.open("GET", url, false);
  xhr.send();
};

var getVisitorCookie = function() {
  return core.getCookieValue("as24Visitor");
};

var trackExperimentEvent = function(experimentId, variationId, eventName, eventId) {
  var visitorCookie = getVisitorCookie();
  return (
    visitorCookie ?
      sendOptimizelyEvent(optimizelyProjectId, eventName, eventId, visitorCookie, experimentId, variationId) :
      undefined
  );
};

var setUpExperimentsTracking = function(experimentsConfig) {

  function findGoalByKey(goals, goalKey) {
    return core.findElement(goals, function(goal) { return goal.key === goalKey; });
  }

  function findExperimentsForGoal(goalKey) {
    return experimentsConfig.map(function(experimentConfig) {
      return (
        findGoalByKey(experimentConfig.goals, goalKey) ? experimentConfig : undefined
      );
    }).filter(function(experimentId) { return experimentId !== undefined; });
  }

  [].forEach.call(document.querySelectorAll("[data-experiment-goal-ids]"), function(eventTriggerer) {
    eventTriggerer.getAttribute("data-experiment-goal-ids")
        .split(",")
        .map(function (goalKey) { return goalKey.trim(); })
        .filter(function(goalKey) { return goalKey && goalKey.length > 0; })
        .forEach(function(goalKey) {
          findExperimentsForGoal(goalKey).forEach(function(experiment) {
            core.addEvent(eventTriggerer, "click", function () {
              trackExperimentEvent(
                experiment.experimentId, experiment.variantId,
                goalKey, findGoalByKey(experiment.goals, goalKey).id
              );
            });
          });
      });
  });
};

var setUpAnalyticsTracking = function(experimentsConfig) {
  gaTracking.addCustomDimension(
    6,
    experimentsConfig.map(function (experimentConfig) {
      return experimentConfig.experimentKey + "=" + experimentConfig.variantKey;
    }).join("|")
  );
};

module.exports = {
  setUp: function() {
    var experimentsConfigElt = document.querySelector("#experiments-configuration");
    if (experimentsConfigElt && experimentsConfigElt.innerHTML) {
      var experimentsConfig = JSON.parse(experimentsConfigElt.innerHTML);
      setUpExperimentsTracking(experimentsConfig);
      setUpAnalyticsTracking(experimentsConfig);
    }
  }
};


